import React, { useState } from "react";
import Logo from "../../components/Logo";
import { Box, Container, ErrorMsg } from "./style";
import LoginButton from "../../components/LoginButton";
import FormInput from "../../components/FormInput";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import ROUTES from "../../routes/routePaths";
import { login } from "../../services/auth";
import { useMutation } from "@tanstack/react-query";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { FiEye, FiEyeOff } from "react-icons/fi";
import Spinner from "../../components/Spinner";

const Login = () => {
  const navigate = useNavigate();
  const { login: authLogin } = useAuth();
  const [showPassword, setShowPassword] = useState(false);

  const mutation = useMutation({
    mutationFn: (data) => login(data),
    onSuccess: (res) => {
      const { token, admin } = res.data.data;
      authLogin(token, admin);
      toast.success("✅ تم تسجيل الدخول بنجاح 🎉", {
        icon: "🔐",
        style: {
          fontFamily: "Noto Kufi Arabic",
          direction: "rtl",
        },
      });
      navigate(ROUTES.REDIRECT);
    },
    onError: (err) => {
      formik.setFieldError(
        "general",
        err.response?.data?.message || "حدث خطأ أثناء تسجيل الدخول"
      );
    },
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("بريد إلكتروني غير صالح")
        .required("البريد مطلوب"),
      password: Yup.string().required("كلمة المرور مطلوبة"),
    }),
    onSubmit: (values) => {
      mutation.mutate(values);
    },
  });

  return (
    <Container>
      <Box onSubmit={formik.handleSubmit}>
        <Logo height={12} width={16} />
        <div>
          <FormInput
            type="text"
            text="البريد الإلكتروني"
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            hasError={formik.touched.email && !!formik.errors.email}
          />
          {formik.touched.email && formik.errors.email && (
            <ErrorMsg>{formik.errors.email}</ErrorMsg>
          )}
        </div>
        <div style={{ position: "relative" }}>
          <FormInput
            type={showPassword ? "text" : "password"} 
            text="كلمة المرور"
            name="password"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            hasError={formik.touched.password && !!formik.errors.password}
          />
          <span
            style={{
              position: "absolute",
              right: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
            }}
            onClick={() => setShowPassword(!showPassword)}
          >
           {showPassword ? <FiEyeOff /> : <FiEye />}
          </span>
          {formik.touched.password && formik.errors.password && (
            <ErrorMsg>{formik.errors.password}</ErrorMsg>
          )}
        </div>

        <LoginButton
          title={mutation.isLoading ?<Spinner size={'20px'} /> : "تسجيل الدخول"}
        />

        {formik.errors.general && (
          <p style={{ color: "red" }}>{formik.errors.general}</p>
        )}
      </Box>
    </Container>
  );
};

export default Login;